module.exports = "//public.zight.com/packs/media/images/upload-copy@3x-2c35e0131a6087448cd02e5945d9ad20.png";